export const pins = [{
    image: 1,
    filter: "אומנות",
    label: "בקטע אמנותי"
  }, {
    image: 2,
    filter: "תרבות ובידור",
    label: "גם תרבות, גם בידור"
  }, {
    image: 3,
    filter: "מדע",
    label: "מדע, אבל מהסוג הכיפי"
  }, {
    image: 4,
    filter: "טבע",
    label: "אוהבים טבע? גם אנחנו"
  }, {
    image: 5,
    filter: "היסטוריה",
    label: "היסטוריה, כי כאן התחלנו"
  }]


// WEBPACK FOOTER //
// ./src/Components/App/filters.js